import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _PaymentLinkFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M16.1094 11C16.6614 11.0004 17.1094 11.4479 17.1094 12C17.1094 12.5521 16.6614 12.9996 16.1094 13H15.4219C14.5855 13 13.9015 13.6842 13.9014 14.5205C13.9014 15.3536 14.5866 16.042 15.4219 16.042H16.1094C16.6614 16.0423 17.1094 16.4899 17.1094 17.042C17.1092 17.5939 16.6613 18.0416 16.1094 18.042H15.4219C13.4797 18.042 11.9014 16.4558 11.9014 14.5205C11.9015 12.5796 13.4809 11 15.4219 11H16.1094Z"
        fill={iconColor}
      />
      <Path
        d="M20.5469 11C22.4888 11.0003 24.0682 12.5855 24.0684 14.5205C24.0684 16.4626 22.4819 18.0417 20.5469 18.042H19.8555C19.3033 18.042 18.8556 17.5941 18.8555 17.042C18.8555 16.4897 19.3032 16.042 19.8555 16.042H20.5469C21.3797 16.0417 22.0684 15.3556 22.0684 14.5205C22.0682 13.6878 21.3818 13.0003 20.5469 13H19.8555C19.3032 13 18.8555 12.5523 18.8555 12C18.8555 11.4477 19.3032 11 19.8555 11H20.5469Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.001 11.6094C23.1717 10.6272 21.9322 10.0004 20.5479 10H19.8555C18.9962 10 18.2655 10.543 17.9824 11.3037C17.6995 10.5432 16.9683 10.0004 16.1094 10H15.4219C12.9288 10.0002 10.9015 12.0274 10.9014 14.5205C10.9014 15.9158 11.5392 17.1688 12.54 18H3.00098C1.34412 18 0 16.6569 0 15V8H24.001V11.6094ZM4.4668 12C3.91451 12 3.4668 12.4477 3.4668 13C3.4668 13.5523 3.91451 14 4.4668 14H7.4668C8.01908 14 8.4668 13.5523 8.4668 13C8.4668 12.4477 8.01908 12 7.4668 12H4.4668Z"
        fill={iconColor}
      />
      <Path
        d="M19.6006 13.5205C20.1526 13.5208 20.6005 13.9685 20.6006 14.5205C20.6006 15.0726 20.1526 15.5202 19.6006 15.5205H16.6006C16.0485 15.5203 15.6006 15.0727 15.6006 14.5205C15.6007 13.9685 16.0486 13.5207 16.6006 13.5205H19.6006Z"
        fill={iconColor}
      />
      <Path
        d="M21.001 0C22.6576 0.000263856 24.001 1.34331 24.001 3V6H0V3C0 1.34315 1.34412 0 3.00098 0H21.001Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const PaymentLinkFilledIcon = assignWithoutSideEffects(_PaymentLinkFilledIcon, {
  componentId: 'PaymentLinkFilledIcon',
});

export default PaymentLinkFilledIcon;
